/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * The payload
 * @export
 * @interface WebhookData
 */
export interface WebhookData {
    /**
     * 
     * @type {string}
     * @memberof WebhookData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookData
     */
    timestamp?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookData
     */
    signature?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookData
     */
    customer?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookData
     */
    subscription?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookData
     */
    invoice?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookData
     */
    transaction?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookData
     */
    credit?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookData
     */
    eventId?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookData
     */
    eventType?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookData
     */
    paymentMethod?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookData
     */
    paymentMethodReference?: string;
    /**
     * 
     * @type {string}
     * @memberof WebhookData
     */
    creditNote?: string;
}

/**
 * Check if a given object implements the WebhookData interface.
 */
export function instanceOfWebhookData(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function WebhookDataFromJSON(json: any): WebhookData {
    return WebhookDataFromJSONTyped(json, false);
}

export function WebhookDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): WebhookData {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'timestamp': !exists(json, 'timestamp') ? undefined : json['timestamp'],
        'signature': !exists(json, 'signature') ? undefined : json['signature'],
        'customer': !exists(json, 'customer') ? undefined : json['customer'],
        'subscription': !exists(json, 'subscription') ? undefined : json['subscription'],
        'invoice': !exists(json, 'invoice') ? undefined : json['invoice'],
        'transaction': !exists(json, 'transaction') ? undefined : json['transaction'],
        'credit': !exists(json, 'credit') ? undefined : json['credit'],
        'eventId': !exists(json, 'event_id') ? undefined : json['event_id'],
        'eventType': !exists(json, 'event_type') ? undefined : json['event_type'],
        'paymentMethod': !exists(json, 'payment_method') ? undefined : json['payment_method'],
        'paymentMethodReference': !exists(json, 'payment_method_reference') ? undefined : json['payment_method_reference'],
        'creditNote': !exists(json, 'credit_note') ? undefined : json['credit_note'],
    };
}

export function WebhookDataToJSON(value?: WebhookData | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'timestamp': value.timestamp,
        'signature': value.signature,
        'customer': value.customer,
        'subscription': value.subscription,
        'invoice': value.invoice,
        'transaction': value.transaction,
        'credit': value.credit,
        'event_id': value.eventId,
        'event_type': value.eventType,
        'payment_method': value.paymentMethod,
        'payment_method_reference': value.paymentMethodReference,
        'credit_note': value.creditNote,
    };
}

